import {
  Grid,
  Stack,
} from '@mantine/core'
import CustomerLocation from '@data/locations/model/customerLocation'
import { ReadOnlyField } from '@components/ui/form/ReadOnlyField'


export interface DeviceLocationTabProps {
  location?:  CustomerLocation | null
}

export const DeviceLocationTab = ({ location }: DeviceLocationTabProps) => {
  return (
    <Stack gap='lg'>
      <Grid>
        <Grid.Col span={12}>
          <ReadOnlyField
            label='Location Name'
            value={location?.name || ''}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={12}>
          <ReadOnlyField
            label='Address Line 1'
            value={location?.addressLine1 || ''}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={12}>
          <ReadOnlyField
            label='Address Line 2'
            value={location?.addressLine2 || ''}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField
            label='Town'
            value={location?.town || ''}
          />
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField
            label='Postcode'
            value={location?.postcode || ''}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField
            label='County'
            value={location?.county || ''}
          />
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField
            label='Country'
            value={location?.country || ''}
          />

        </Grid.Col>
      </Grid>
    </Stack>
  )
}